<script setup>
/* eslint-disable */
import { computed } from 'vue';
import { applyThemeClasses } from '@/utils/themeColors'

const props = defineProps({
  personalBests: {
    type: Object,
    required: true,
    default: () => ({})
  }
});

const RACE_TYPES = [
  { type: 'short', label: '800m Sprint' },
  { type: 'medium', label: '2000m Race' },
  { type: 'long', label: '5000m Endurance' }
  
];

const hasRaces = computed(() => {
  return Object.keys(props.personalBests).length > 0;
});

const formatPersonalBest = (pb) => {
  if (!pb) return 'No races';
  const minutes = Math.floor(pb / 60);
  const seconds = Math.floor(pb % 60);
  const milliseconds = Math.floor((pb % 1) * 1000);
  return `${minutes}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(3, '0')}`;
};
</script>

<template>
  <div class="space-y-2">
    <div class="text-sm font-medium mb-1"><span :class="applyThemeClasses('text.secondaryBold')">Personal Best Times (m:ss.sss)</span></div>
    <div v-if="!hasRaces" class="text-sm text-gray-500 italic">
      <div class="flex justify-between items-center text-xs"><span :class="applyThemeClasses('text.secondary')">800m:</span><span class="font-medium text-gray-400">-</span></div>
      <div class="flex justify-between items-center text-xs"><span :class="applyThemeClasses('text.secondary')">2000m:</span><span class="font-medium text-gray-400">-</span></div>
      <div class="flex justify-between items-center text-xs"><span :class="applyThemeClasses('text.secondar')">5000m:</span><span class="font-medium text-gray-400">-</span></div>
    </div>
    <template v-else>
      <div 
        v-for="race in RACE_TYPES" 
        :key="race.type"
        class="flex justify-between items-center text-sm"
      >
        <span class="text-gray-600">{{ race.label }}</span>
        <span 
          :class="[
            'font-medium',
            personalBests[race.type] ? 'text-blue-600' : applyThemeClasses('text.secondary')
          ]"
        >
        <span :class="applyThemeClasses('text.secondaryBold')">{{ formatPersonalBest(personalBests[race.type]) }}</span>
        </span>
      </div>
    </template>
  </div>
</template>